<template>
    <div :title="title"
        :class="['x-status', `x-status--${type}`]"></div>
</template>

<script>
export default {
    name: 'XStatus',

    props: {
        title: String,
        type: {
            type: String,   // loading | success | error | waiting | normal
            required: true
        }
    },
}
</script>

<style lang="less" scoped>
// src/common/less/dev/.less
.x-status {
    display: inline-block;
    position: relative;
    height: 24px;
    width: 24px;
    vertical-align: middle;
    font-size: 0;

    &::before {
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 50%;
    }

    &--success {
        &::before {
            background: #0ED2A6;
            box-shadow: 0 0 6px 0 rgba(14,210,166,.5);
        }
    }
    &--error {
        &::before {
            background: #F26175;
            box-shadow: 0 0 6px 0 rgba(242,97,117,.5);
        }
    }
    &--waiting {
        &::before {
            background: #F0B300;
            box-shadow: 0 0 6px 0 rgba(240,179,0,.5);
        }
    }

    &--loading {
        &::before {
            background: url("~src/common/img/icon-status-loading.png") no-repeat center;
            animation: rotate 1s infinite linear;
        }
    }

    &--normal {
        &::before {
            background: #CFD2E4;
            box-shadow: 0 0 6px 0 rgba(207,210,228,0.50);
        }
    }
}
</style>

